import { QuizConfigMap } from './types'
import menoscaleConfig from './menoscale.config'
import e4Config from './e4.config'
import e5Config from './e5.config'
import e6Config from './e6.config'
import e7Config from './e7.config'
import e8Config from './e8.config'
import e9Config from './e9.config'
import e10Config from './e10.config'
import e11Config from './e11.config'
import e12Config from './e12.config'
import guestPassConfig from './guest-pass.config'

const DEFAULT_QUIZ_CONFIG: QuizConfigMap = {
  menoscale: menoscaleConfig,
  e4: e4Config,
  e5: e5Config,
  e6: e6Config,
  e7: e7Config,
  e8: e8Config,
  e9: e9Config,
  e10: e10Config,
  e11: e11Config,
  e12: e12Config,
  'guest-pass': guestPassConfig,
} as const

export default DEFAULT_QUIZ_CONFIG
